/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteContextListResponse } from '../../models/site-context-list-response';

export interface GetSiteContexts$Params {
}

export function getSiteContexts(http: HttpClient, rootUrl: string, params?: GetSiteContexts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteContextListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getSiteContexts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SiteContextListResponse>>;
    })
  );
}

getSiteContexts.PATH = '/me/available-site-contexts';
